import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export const fetchUploadedProjectFiles = async (
  projectId,
  userType,
  folder,
) => {
  const res = await axios.get(
    `/api/uploaded-project-files/${projectId}/${folder}/${userType}/`,
    {
      withCredentials: true,
    },
  );
  return res.data;
};

const useUploadedProjectFiles = (projectId, userType, folder) => {
  return useQuery({
    queryKey: ["uploaded-project-files", projectId, folder, userType],
    queryFn: () => fetchUploadedProjectFiles(projectId, userType, folder),
    enabled: !!projectId,
  });
};

export default useUploadedProjectFiles;
